import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"

import "alpine-turbo-drive-adapter"
import Alpine from "alpinejs"

import { init_toasts } from "./toasts"
import "./creatable_select"
import "./project_graph"

window.Alpine = Alpine

Alpine.data("modifier_table", () => ({
  open_edit(url) {
    document.getElementById("edit-modifier-frame").src = url
    bootstrap.Offcanvas.getOrCreateInstance(
      document.getElementById("edit-modifier-offcanvas")
    ).show()
  }
}))

Alpine.data("search_form", () => ({
  async search(event) {
    const query = event.target.querySelector('input[name="q"]').value.trim()
    if (!query) return
    try {
      const url = new URL("/search", window.location.origin)
      url.searchParams.set("q", query)
      const response = await fetch(url.toString(), { headers: { Accept: "application/json" } })
      const data = await response.json()
      document.dispatchEvent(new CustomEvent("app:toast", {
        detail: { message: data.message ?? "Search is not yet available.", type: "warning" }
      }))
    } catch {
      document.dispatchEvent(new CustomEvent("app:toast", {
        detail: { message: "Search is currently unavailable.", type: "danger" }
      }))
    }
  }
}))

Alpine.start()
document.addEventListener("turbo:load", init_toasts)
window.addEventListener("load", init_toasts)

document.addEventListener("turbo:submit-end", (event) => {
  if (event.detail.success) {
    const form = event.target

    // If the submitted form lives inside a modifier offcanvas ("Add" flow),
    // reset all inputs so the form is clean the next time it opens.
    if (form && form.closest(".modifier-offcanvas")) {
      // Reset native form fields to their blank default values
      form.reset()

      // Reset Alpine.js reactive state within the form.
      // The time_period fields partial uses x-data="{ every: '' }" and
      // the continuous fields partial uses x-data="{ continuous: true }".
      // Without this, x-show / x-if conditions stay stale.
      form.querySelectorAll("[x-data]").forEach((el) => {
        try {
          const data = Alpine.$data(el)
          if ("every" in data) data.every = ""
          if ("continuous" in data) data.continuous = true
        } catch (_) {
          // Not an Alpine component; skip.
        }
      })

      // Clear server-side validation feedback from a prior failed submission
      form.querySelectorAll(".is-invalid").forEach((el) => el.classList.remove("is-invalid"))
      form.querySelectorAll(".invalid-feedback").forEach((el) => el.remove())
    }

    // Hide any open modifier offcanvas (existing behaviour)
    document.querySelectorAll(".modifier-offcanvas.show").forEach((el) => {
      bootstrap.Offcanvas.getInstance(el)?.hide()
    })
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body?.classList.remove("modal-open")
  }
})
